<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content [formGroup]="form">
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Comentario para gestoría</mat-label>
    <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="8" formControlName="comments"></textarea>
  </mat-form-field>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Comentario para empleado</mat-label>
    <textarea matInput cdkTextareaAutosize cdkAutosizeMinRows="3" cdkAutosizeMaxRows="8" formControlName="comment_for_employee"></textarea>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button color="accent" type="button" (click)="save()">Guardar</button>
</mat-dialog-actions>
